import React from 'react';
import { FaLinkedinIn, FaFacebookF, FaInstagram } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="https://preciseca.com/wp-content/uploads/2025/12/precisecaLogo.png" alt="PreciseCA" />
            <p>&copy; {new Date().getFullYear()} PreciseCA. All rights reserved.</p>
          </div>
          <div className="footer-links">
            <a href="#home">Precise CA</a>
            <a href="#features">Features</a>
            <a href="#about">About Us</a>
            <a href="#faq">FAQ</a>
          </div>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/preciseca" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.facebook.com/preciseca" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/preciseca" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
